import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListProductInformationStyles {
    container?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    labels?: InjectableCss;
}

export const productInformationStyles: ProductListProductInformationStyles = {
    container: {
        gap: 10,
        css: css`
            width: 100%;
            padding: 0.625rem 0.75rem 0 0.75rem;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0.625rem 0.75rem 0 0;
                    `,
                    css`
                        padding: 0.625rem 0.75rem 0 0;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
   
    descriptionGridItem: {
        width: 12,
    },
    labels: {
        css: css`
            font-size: 14px;
            margin-bottom: 5px;
        `
    }
};

const styles = productInformationStyles;

const ProductDIsplayComingSoon = ({
    productContext,
}: Props) => {
    const { product } = productContext;

    if (!product) {
        return null;
    }

    const { customActivateOn } = product.properties; 
    
    const labelComingSoon = customActivateOn ? (new Date(customActivateOn) >= new Date()) ? "Coming Soon" : "": "";

    return (
        <>
            {labelComingSoon !== "" && (
                <Typography {...styles.labels}>{translate(labelComingSoon)}</Typography>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDIsplayComingSoon)),
    definition: {
        group: "Products",
        displayName: "Product Coming Soon",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
